// test1165
(1165 && 0);
